import { TeoCore } from '../TeoCore';
import { AnalysisResult } from './AnalysisResult';
import type { GeneratorHistoryEntry } from './generator/GeneratorHistoryEntry';
import { GeneratorStore } from './generator/GeneratorStore';
import type { TeoText } from './TeoText';
import type { TeoView } from './TextUi';

export type GeneratorUiHandlerStoredState = {
  history: GeneratorHistoryEntry[];
  selectedHistory: number;
};

export class GeneratorUiHandler {
  public readonly store: GeneratorStore;

  constructor(
    private text: TeoText,
    storedState:
      | GeneratorUiHandlerStoredState
      | { state: GeneratorUiHandlerStoredState }
      | undefined = undefined,
  ) {
    if (storedState) {
      this.store = new GeneratorStore(
        text,
        'state' in storedState ? storedState.state : storedState,
      );
    } else {
      this.store = new GeneratorStore(text);
    }
    this.text.core.dynamicConfig.addEventListener(
      'promptOptionTemplates',
      this.updateTemplates.bind(this),
    );
    this.updateTemplates();
  }

  public changeSelectedHistory(page: number) {
    this.store.selectHistory(page);
  }

  generateText() {
    return this.store.generate();
  }

  async createTextTab(options?: { view?: TeoView }) {
    const newText = this.text.core.duplicateText(this.text.id);
    if (!newText) {
      return;
    }
    this.text.core.switchText(newText.id);
    if (options?.view) {
      newText.store.setStateValue('view', options.view);
    }
    newText.isEditable = true;
    newText.events.triggerEvent('textChanged', newText.text);
    const data = newText.getTextData();
    if (data.analysis?.data) {
      newText.events.triggerEvent(
        'gotAnalysis',
        new AnalysisResult(data.analysis.data, newText, data.text),
      );
    }
    // create a history entry
    newText.history?.addHistoryEntry();
    newText.save();

    // Keep for reference...
    // TODO: remove this after testing

    // const textData = this.text.getTextData();

    // if (newText) {
    //   newText.isEditable = true;
    //   newText.updateText(textData.text, textData.serialized);
    //   newText.events.triggerEvent('textChanged', textData.text);
    //   newText.analysisConfiguration = textData.analysisConfiguration;
    //   if (textData.analysis?.data) {
    //     alert('updateResult');
    //     newText.updateResult(textData.analysis.data, textData.text);
    //   }
    //   // if (this.store.currentHistory.textData) {
    //   //   newText.updateTextData(this.store.currentHistory.textData);
    //   // }
    //   this.text.core.switchText(newText.id);
    //   // const analysisData = this.text.analysis?.data;
    //   // if (analysisData) {
    //   //   alert('gotAnalysis');
    //   //   newText.updateResult(analysisData, this.text.text);
    //   //   newText.events.triggerEvent(
    //   //     'gotAnalysis',
    //   //     new AnalysisResult(analysisData, newText, this.text.text),
    //   //   );
    //   //   newText.events.triggerEvent('analysisStateChanged', void 0);
    //   //   newText.events.triggerEvent('analysisReadinessChanged', true);
    //   //   // newText.analysis = new AnalysisResult(analysisData, newText, this.text.text);
    //   // }
    //   newText.store.setStateValue('view', 'performance');

    //   // Until we have a proper way (reactiveStore) we need to manually store the text
    //   newText.save();
    // }
  }

  private updateTemplates() {
    this.store.setStateValue('loading', true);
    const availableTemplates = TeoCore.current.dynamicConfig.options.promptOptionTemplates;
    if (!availableTemplates) {
      return;
    }
    this.store.setStateValue('loading', false);
  }

  toJSON() {
    if (this.text.core.dynamicConfig.options.textGeneratorEnabled) {
      return this.store.toJSON();
    }
    return undefined;
  }
}
